import { FC } from 'react'
import { Outlet } from 'react-router-dom'
import useNavigationAuthorization from '../hooks/useNavigationAuthorization'
import useRouteAuthorization from '../hooks/useRouteAuthorization'
import WithoutAccess from './WithoutAccess'
import Forbidden from './Forbidden'

const AuthorizationGuard: FC = (): React.ReactElement => {
  const isUserAllowedToNavigate = useNavigationAuthorization()
  const isUserAllowedToAccessCurrentRoute = useRouteAuthorization()

  if (!isUserAllowedToNavigate) return <WithoutAccess />
  else if (!isUserAllowedToAccessCurrentRoute) return <Forbidden />
  else return <Outlet />
}

export default AuthorizationGuard
